import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, Pagination, TextField } from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import { t } from "i18next";
import { useEffect, useState } from "react";

function Khuyenmai() {
    function formatDate(m) {
        if (!m) return "";
        const d = new Date(m);
        if (isNaN(d.getTime())) return String(m);
        const YYYY = d.getUTCFullYear();
        const MM = ("0" + (d.getMonth() + 1)).slice(-2);
        const DD = ("0" + d.getDate()).slice(-2);
        const hh = ("0" + d.getHours()).slice(-2);
        const mm = ("0" + d.getMinutes()).slice(-2);
        return `${YYYY}/${MM}/${DD}  ${hh}:${mm}`;
    }

    const [data, setData] = useState(null);
    const [data2, setData2] = useState(null);
    const [load, setLoad] = useState(true);
    const [note, setNote] = useState(null);

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    const [searched, setSearched] = useState("");
    const [pages, setPage] = useState(1);

    const requestSearch = (searchedVal) => {
        setSearched(searchedVal);
        if (searchedVal !== "") {
            const filteredRows = (data2 || []).filter((row) => {
                return row?.user?.username?.toString().toLowerCase().includes(searchedVal.toLowerCase());
            });
            setData(filteredRows);
            setPage(1);
        } else {
            setData(data2);
        }
    };

    const handleChange = (e, page) => {
        setPage(page);
    };

    const [envelopeHistory, setEnvelopeHistory] = useState([]);
    const [loadEnvelopes, setLoadEnvelopes] = useState(true);

    useEffect(() => {
        if (loadEnvelopes === true) {
            axios.get(`${process.env.REACT_APP_API_URL}/red-envelope/history`)
                .then(res => {
                    if (res.data.success) {
                        setEnvelopeHistory(res.data.data);
                    }
                    setLoadEnvelopes(false);
                }).catch(err => {
                    console.error("Lỗi lấy lịch sử lì xì:", err);
                    setLoadEnvelopes(false);
                });
        }
    }, [loadEnvelopes]);

    useEffect(() => {
        if (load === true) {
            axios
                .get(`${process.env.REACT_APP_API_URL}/payment/khuyenmai`, {})
                .then((res) => {
                    setData(res.data.data || []);
                    setData2(res.data.data || []);
                    setLoad(false);
                })
                .catch((err) => {
                    console.error(err);
                    setData([]);
                    setData2([]);
                    setLoad(false);
                });
        }
    }, [load]);

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" sx={{ flexGrow: 1, py: 1 }}>
                    {load && (
                        <div className="loading" style={{ maxWidth: "100%", zIndex: 9999 }}>
                            <div className="loader"></div>
                        </div>
                    )}
                    <Container maxWidth={false}>
                        <div className="container_set">{t('promotion')}</div>
                        
                        {/* --- GIAO DIỆN PHÁT LÌ XÌ --- */}
                        <div style={{ display: 'flex', gap: '20px', marginBottom: '25px', flexWrap: 'wrap' }}>
                            {/* Box 1: Mưa lì xì */}
                            <Box sx={{ p: 3, flex: 1, minWidth: '320px', bgcolor: '#ffebee', borderRadius: 2, border: '1px solid #ffcdd2', display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#c62828' }}>🧧 KÍCH HOẠT CƠN MƯA LÌ XÌ (TOÀN SERVER)</div>
                                <form onSubmit={(e) => {
                                    e.preventDefault();
                                    const amountInput = Number(e.target.rain_amount.value || 0);
                                    const amount = amountInput * 1000;
                                    if (!amount || amount <= 0) return swal("Lỗi", "Số điểm không hợp lệ!", "error");
                                    axios.post(`${process.env.REACT_APP_API_URL}/red-envelope/drop-all`, { amount: amount })
                                        .then((res) => {
                                            swal("Thành công", `Đã kích hoạt cơn mưa lì xì trị giá ${amountInput.toLocaleString()} điểm toàn hệ thống!`, "success");
                                            e.target.rain_amount.value = "";
                                            setLoadEnvelopes(true);
                                        }).catch((err) => swal("Thất bại", "Lỗi kích hoạt cơn mưa lì xì!", "error"));
                                }} style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                                    <TextField size="small" type="number" name="rain_amount" label="Tổng ngân sách Lì Xì (điểm)" sx={{ bgcolor: 'white', flex: 1 }} />
                                    <Button variant="contained" color="error" type="submit" sx={{ height: '40px', fontWeight: 'bold' }}>🧧 Rải Mưa</Button>
                                </form>
                            </Box>

                            {/* Box 2: Phát lì xì đích danh */}
                            <Box sx={{ p: 3, flex: 1, minWidth: '320px', bgcolor: '#e8f5e9', borderRadius: 2, border: '1px solid #c8e6c9', display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#2e7d32' }}>🧧 PHÁT LÌ XÌ TRỰC TIẾP (CHO TỪNG USER)</div>
                                <form onSubmit={(e) => {
                                    e.preventDefault();
                                    const username = e.target.username.value;
                                    const amountInput = Number(e.target.amount.value || 0);
                                    const amount = amountInput * 1000;
                                    if (!username.trim() || !amount || amount <= 0) return swal("Lỗi", "Thông tin không hợp lệ!", "error");
                                    axios.post(`${process.env.REACT_APP_API_URL}/red-envelope/send-user`, { username: username, amount: amount })
                                        .then((res) => {
                                            swal("Thành công", `Đã phát lì xì trị giá ${amountInput.toLocaleString()} điểm cho user ${username}!`, "success");
                                            e.target.username.value = "";
                                            e.target.amount.value = "";
                                            setLoadEnvelopes(true);
                                        }).catch((err) => swal("Thất bại", err.response?.data?.message || "Lỗi phát lì xì đích danh!", "error"));
                                }} style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                                    <TextField size="small" type="text" name="username" label="Tên người nhận" sx={{ bgcolor: 'white', flex: 1 }} />
                                    <TextField size="small" type="number" name="amount" label="Số điểm lì xì" sx={{ bgcolor: 'white', flex: 1 }} />
                                    <Button variant="contained" color="success" type="submit" sx={{ height: '40px', fontWeight: 'bold' }}>🧧 Gửi</Button>
                                </form>
                            </Box>
                        </div>

                        {/* --- BẢNG LỊCH SỬ RẢI LÌ XÌ --- */}
                        <div className="container_set" style={{ marginTop: '20px', fontSize: '20px' }}>Lịch sử rải Lì xì</div>
                        <div className="form_set" style={{ marginBottom: '25px' }}>
                            <Table className="table-admin">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Loại Lì Xì</TableCell>
                                        <TableCell>Người Nhận</TableCell>
                                        <TableCell>Số điểm</TableCell>
                                        <TableCell>Trạng Thái</TableCell>
                                        <TableCell>Ngày Phát</TableCell>
                                        <TableCell>Người đã giật / Số điểm</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {envelopeHistory.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={6} align="center">Chưa có lịch sử phát lì xì nào</TableCell>
                                        </TableRow>
                                    ) : (
                                        envelopeHistory.map((env) => (
                                            <TableRow key={env._id}>
                                                <TableCell sx={{ fontWeight: 'bold' }}>
                                                    {env.type === 'RAIN' ? (
                                                        <span style={{ color: '#c62828' }}>🧧 Mưa Lì Xì</span>
                                                    ) : (
                                                        <span style={{ color: '#2e7d32' }}>👤 Đích Danh</span>
                                                    )}
                                                </TableCell>
                                                <TableCell>{env.user ? env.user.username : "Toàn Server"}</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold' }}>{Math.floor((env?.amount || 0) / 1000)?.toLocaleString("vi-VN")} điểm</TableCell>
                                                <TableCell>
                                                    {env.status === 'Pending' ? (
                                                        <span className="badge warning">Chờ nhận</span>
                                                    ) : env.status === 'Claimed' ? (
                                                        <span className="badge success">Đã nhận hết</span>
                                                    ) : (
                                                        <span className="badge error">Hết hạn</span>
                                                    )}
                                                </TableCell>
                                                <TableCell>{formatDate(env.createdAt)}</TableCell>
                                                <TableCell>
                                                    {env.claimedBy && env.claimedBy.length > 0 ? (
                                                        <div style={{ maxHeight: '60px', overflowY: 'auto', fontSize: '12px' }}>
                                                            {env.claimedBy.map((c, i) => (
                                                                <div key={i}>
                                                                    <strong>{c?.user?.username || "Ẩn danh"}:</strong> +{Math.floor((c?.amount || 0) / 1000)?.toLocaleString("vi-VN")} điểm
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <span style={{ color: '#999', fontSize: '12px' }}>Chưa ai nhận</span>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </div>

                        <div className="form_set">
                            <Box>
                                <TextField value={searched} onChange={(searchVal) => requestSearch(searchVal.target.value)} placeholder={t('search')} />
                                <Table className="table-admin">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>{t('username')}</TableCell>
                                            <TableCell>ID</TableCell>
                                            <TableCell>Số điểm</TableCell>
                                            <TableCell>{t('promotion')}</TableCell>
                                            <TableCell>{t('status')}</TableCell>
                                            <TableCell>{t('more')}</TableCell>
                                            <TableCell>{t('time')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data && data.length > 0 ? (
                                            data.slice((pages - 1) * 15, (pages - 1) * 15 + 15).map((item) => (
                                                <TableRow key={item._id}>
                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.user?.username}</TableCell>
                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.user?.iduser}</TableCell>
                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{Math.floor((item?.money || 0) / 1000)?.toLocaleString("vi-VN")} điểm</TableCell>
                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.km != null ? Math.floor(Number(item.km) / 1000).toLocaleString("vi-VN") : ""}</TableCell>
                                                    <TableCell>
                                                        {item?.status_payment === "Pending" && <span className="badge warning">{item?.status_payment}</span>}
                                                        {item?.status_payment === "Success" && <span className="badge success">{item?.status_payment}</span>}
                                                        {item?.status_payment === "Deny" && <span className="badge error">{item?.status_payment}</span>}
                                                    </TableCell>
                                                    <TableCell>
                                                        <textarea
                                                            type="text"
                                                            name={`note-${item?._id}`}
                                                            value={item?.note}
                                                            disabled={item?.status_payment !== "Pending"}
                                                            onChange={(e) => setNote(e.target.value)}
                                                        />
                                                        <Button
                                                            onClick={() => {
                                                                const formData = {
                                                                    id: item?._id,
                                                                    status: "Accept",
                                                                    note: note
                                                                };
                                                                axios
                                                                    .post(`${process.env.REACT_APP_API_URL}/payment/update`, formData)
                                                                    .then(() => {
                                                                        swal(t('success'), "", "success").then(() => window.location.reload());
                                                                    })
                                                                    .catch(() => setLoad(true));
                                                            }}
                                                            disabled={item?.status_payment !== "Pending"}>
                                                            {t('submit')}
                                                        </Button>
                                                        <Button
                                                            onClick={() => {
                                                                const formData = {
                                                                    id: item?._id,
                                                                    status: "Deny",
                                                                    note: note
                                                                };
                                                                axios
                                                                    .post(`${process.env.REACT_APP_API_URL}/payment/update`, formData)
                                                                    .then(() => {
                                                                        swal(t('success'), "", "success").then(() => window.location.reload());
                                                                    })
                                                                    .catch(() => setLoad(true));
                                                            }}
                                                            disabled={item?.status_payment !== "Pending"}>
                                                            {t('deny')}
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{formatDate(item?.createdAt)}</TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={7} align="center">Không có dữ liệu khuyến mãi</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </Box>
                        </div>
                        <Box sx={{ display: "flex", justifyContent: "center", pt: 3 }}>
                            {data && data.length > 0 ? (
                                <Pagination color="primary" count={Math.ceil(data.length / 15)} size="small" onChange={handleChange} />
                            ) : null}
                        </Box>
                    </Container>
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default Khuyenmai;
